import { ReadableElement } from './base';
export class MeterElement extends ReadableElement {
    constructor(element, permissionChecker, variableCommunicator, variableStore, localization) {
        super(element, permissionChecker, variableCommunicator, variableStore, localization);
        this.cx = 0;
        this.cy = 0;
        this.offsetY = 0;
        let mainEl$;
        if (this.model.version && this.model.version > 3) {
            mainEl$ = this.$element.find('[data-id="main"]');
            this.$handEl = this.$element.find('[data-id="hand"]');
            this.arcPath$ = this.$element.find('[data-id="arc"]');
        }
        else {
            mainEl$ = this.$element.children().eq(0);
            this.$handEl = this.$element.find('path[fill=\'red\']'); // 用g:first > path:eq(0)取handle可能因为多次封装取不到所以通过属性取handle
            this.arcPath$ = this.$element.find('g:first > g:first > path:eq(0)');
        }
        if (this.$handEl.length !== 1) {
            throw new Error('missing meter hand.');
        }
        this.mainElementTransform = mainEl$.attr('transform');
        const snapEl = Snap(this.$handEl[0]);
        const bBox = snapEl.getBBox(true);
        const radius = (bBox.x + bBox.width) / 2;
        this.cx = radius;
        this.cy = radius - bBox.x;
        this.offsetY = radius - (bBox.height / 2);
        setTimeout(() => {
            this.initFrameNode();
            this.changeStates();
        });
    }
    updateVariableValue(value) {
        const angle = this.getAngle(value);
        this.$handEl.attr('transform', this.mainElementTransform + ` translate(0,${this.offsetY}) rotate(${angle}, ${this.cx}, ${this.cy})`);
    }
    initFrameNode() {
        const b = Snap(this.$element[0]).getBBox();
        this.rootElement.append('rect').attr('id', 'StateFrame').attr('width', b.width).attr('height', b.height).attr('fill', 'transparent');
    }
    getAngle(value) {
        const min = this.model.min;
        const max = this.model.max;
        value = Math.min(Math.max(value, min), max);
        const len = (value - min) / (max - min);
        const arcPath = Snap(this.arcPath$[0]);
        const b = arcPath.getBBox(true);
        const point = arcPath.getPointAtLength(len * arcPath.getTotalLength());
        const angle = this.directionPoint({ x: b.width / 2, y: b.height / 2 }, point);
        return angle;
    }
    directionPoint(point1, point2) {
        const a = point2.x - point1.x;
        const b = point2.y - point1.y;
        if (0 === a) {
            return 0 < b ? 90 : 0 > b ? 270 : 0;
        }
        if (0 === b) {
            return 0 < a ? 0 : 180;
        }
        if (isNaN(a) || isNaN(b)) {
            return 0;
        }
        let c = 180 * Math.atan(Math.abs(b / a)) / Math.PI;
        // eslint-disable-next-line no-unused-expressions
        0 > a ? c = 0 > b ? c + 180 : 180 - c : 0 > b && (c = 360 - c);
        return c;
    }
}
